import "./general-tab.scss";

import * as React from "react";

import {cst, cstAssign}        from "@Common/react/chain-services";
import {consumeContext}        from "@Common/react/context";
import {Types}                 from "@Common/types";
import {equalDeep, filterKeys} from "@Common/utils/objects";

import {GeneralFormState}                   from "../../common/general-form-state";
import {makeFieldFactory, makeInputFactory} from "../common/tab-fields";

type FormModel = Types.Xpresso.Account.Admin.OfficeManagement.Common.General.FormModel;

const FIELD_LABELS = {
    branchLinkId      : "Link ID",
    branchAdmin1Email : "Email",
    branchAdmin1Name  : "Name",
    branchAdmin2Email : "Email",
    branchAdmin2Name  : "Name",
    branchEmail       : "Email",
    branchManagerName : "Mgr Name",
    branchName        : "Name",
    branchPhone1      : "Phone 1",
    branchPhone2      : "Phone 2",
}

export const GeneralTab = ({
    branch,
    disabled,
    hasUnsavedChangesStatic : {set: setHasUnsavedChanges},
    onSave                  : emitSave,
    resetCallbackSetter     : setResetCallback,
}:{
    branch                   : Types.Apis.Payloads.Next.Branch.GetById.Response,
    disabled                ?: boolean,
    hasUnsavedChangesStatic  : Types.Common.React.Static2.Static2Next<boolean>,
    onSave                   : (saving:Promise<void>) => void,
    resetCallbackSetter      : (reset:() => void) => void,
}): React.FunctionComponentElement<any> => cst<{
    allowEditBranchLinkID   : any,
    apis                    : Types.Apis.Loaders.XpressoLoadApis,
    company                 : any,
    formState               : Types.Xpresso.Account.Admin.OfficeManagement.Common.General.FormStateNext,
    fieldFactory            : Types.Xpresso.Account.Admin.OfficeManagement.ManagementModal.TabFieldFactory<FormModel>,
}>(
    consumeContext("apis"),
    consumeContext("company"),
    cstAssign("allowEditBranchLinkID", ({company}, next) => next(company?.prefs?.allowEditBranchLinkID)),
    cstAssign("formState", ({}, next) => GeneralFormState({branch, next})),
    ({formState}, next) => next(setResetCallback(() => formState.fromValue(branch))),
    cstAssign("fieldFactory", ({formState}, next) => next(makeFieldFactory({formState, inputFactory: makeInputFactory({formState, branch, setHasUnsavedChanges})}))),
    ({apis, formState, fieldFactory: makeField, allowEditBranchLinkID}) => (
        <div className="general-info-tab-45f" xd-qa-type="card" xd-qa-name="General Info">
            <header xd-qa-type="label" xd-qa-name="Office General Info">Office General Info</header>
            <section>
                <header xd-qa-type="label" xd-qa-name="Office">Office</header>
                {makeField({disabled, path: "branchName", label: FIELD_LABELS["branchName"], xdQaName: "Office "})}
                {makeField({disabled: (disabled || !allowEditBranchLinkID), path: "branchLinkId", label: FIELD_LABELS["branchLinkId"], xdQaName: "Office "})}
                {([
                    "branchPhone1",
                    "branchPhone2",
                    "branchEmail",
                    "branchManagerName",
                ] as const).map((path) => (
                    makeField({disabled, path, label: FIELD_LABELS[path], xdQaName: "Office "})
                ))}
            </section>

            <section>
                <header xd-qa-type="label" xd-qa-name="Admin 1">Admin 1</header>
                {(["branchAdmin1Name", "branchAdmin1Email"] as const).map((path) => (
                    makeField({disabled, path, label: FIELD_LABELS[path], xdQaName: "Admin 1 "})
                ))}
            </section>

            <section>
                <header xd-qa-type="label" xd-qa-name="Admin 2">Admin 2</header>
                {(["branchAdmin2Name", "branchAdmin2Email"] as const).map((path) => (
                    makeField({disabled, path, label: FIELD_LABELS[path], xdQaName: "Admin 2 "})
                ))}
            </section>

            <button
                disabled={disabled || equalDeep(formState.value, filterKeys(branch ?? {}, (key) => key in formState.value)) || !formState.validate()}
                onClick={() => {
                    emitSave(apis.next.branch.updateBasicInfo({idBranch: branch.idBranch, ...formState.value}))
                }}
                xd-qa-type="button"
                xd-qa-name="Save"
            >
                Save
            </button>
        </div>
    )
);

